<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>My Account</h1>
    </div>

    <div class="container">
      <br>
      <h4>User Fields</h4>
      <div class="row">
        <div class="col-sm-4">
          <label for="">Email</label>
          <input
            v-model.trim="user.email"
            type="email"
            class="form-control client-form-control input-lg"
            placeholder="Email">
        </div>
        <div class="col-sm-4">
          <label for="">Password</label>
          <input
            v-model.trim="password"
            type="password"
            class="form-control client-form-control input-lg"
            placeholder="Password">
        </div>
        <div class="col-sm-4">
          <label for="">Confirm</label>
          <input
            v-model.trim="confirm"
            type="password"
            class="form-control client-form-control input-lg"
            placeholder="Confirm Password">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <label for="">Address</label>
          <input
            v-model.trim="user.address"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="Address">
        </div>
        <div class="col-sm-3">
          <label for="">City</label>
          <input
            v-model.trim="user.city"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="City">
        </div>
        <div class="col-sm-2">
          <label for="">State</label>
          <select
            v-model="user.state"
            class="form-control client-form-control input-lg">
            <option :value="'' || undefined" disabled selected>States</option>
            <option
              v-for="(state, index) in states" :key="index"
              :value="state">
              {{ state }}
            </option>
          </select>
        </div>
        <div class="col-sm-3">
          <label for="">Zip</label>
          <input
            v-model.trim="user.zip"
            type="text"
            class="form-control client-form-control input-lg"
            placeholder="Zip">
        </div>
      </div>
      <div class="registration-form">
        <public-edit-form
          :fields="fields"
          :completedForm="completedRegistration"></public-edit-form>
      </div>
      <br>
      <div class="col-sm-6 col-sm-offset-3">
        <br>
        <a
          @click.prevent="save"
          href=""
          :class="saveClasses"
          type="button">
          Save
        </a>
        <br>
      </div>
    </div><!-- container -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PublicEditForm from '../../components/client/editForm/PublicEditForm'

export default {
  name: 'Account',
  components: {
    'public-edit-form': PublicEditForm
  },
  mounted () {
    // this.getLoyaltyProgramBySlug(this.$store.state.slug)
  },
  watch: {

  },
  data () {
    return {
      password: null,
      confirm: null,
      states: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District of Columbia',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ]
    }
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ]),
    ...mapState('user', [
      'user'
    ]),
    fields () {
      return this.program.registrationForm.formItems.filter(item => item.editable)
    },
    completedRegistration () {
      return this.user.userLoyaltyProgram.completedRegistration
    },
    validatePasswords () {
      return this.confirm === this.password
    },
    saveClasses () {
      const defaultClasses = 'btn client-btn-primary btn-lg btn-block text-uppercase'
      return this.validatePasswords ? defaultClasses : defaultClasses + ' disabled'
    }
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ]),
    ...mapActions('user', [
      'clientUpdateUserLoyaltyProgram',
      'updateUser'
    ]),
    async save () {
      if (this.password && this.validatePasswords) {
        this.user.password = this.password
      }
      try {
        await this.clientUpdateUserLoyaltyProgram({
          id: this.user.userLoyaltyProgram._id,
          userLoyaltyProgram: { completedRegistration: this.completedRegistration }
        })
        await this.updateUser({
          id: this.user._id,
          user: this.user
        })
        this.$bus.emit('notify', { message: 'Successfully saved user!', type: 'info' })
      } catch (err) {
        if (err.response.data.error.msg) {
          this.$bus.emit('notify', { message: err.response.data.error.msg, type: 'danger', time: 4000 })
        } else {
          this.$bus.emit('notify', { message: 'Failed to save user', type: 'danger', time: 4000 })
        }
      }

      // this.clientUpdateUserLoyaltyProgram({
      //   id: this.user.userLoyaltyProgram._id,
      //   userLoyaltyProgram: { completedRegistration: this.completedRegistration }
      // })
      //   .then(() => {
      //     return this.updateUser({
      //       id: this.user._id,
      //       user: this.user
      //     })
      //   })
      //   .then((result) => {
      //     this.$bus.emit('notify', { message: 'Successfully saved user!', type: 'info' })
      //     // alert('Successfully saved.')
      //   })
      //   .catch(err => {
      //     console.log(err.response.data)
      //     if (err.response.data.error.msg) {
      //       this.$bus.emit('notify', { message: err.response.data.error.msg, type: 'danger', time: 4000 })
      //     } else {
      //       this.$bus.emit('notify', { message: 'Failed to save user', type: 'danger', time: 4000 })
      //     }
      //   })
    }
  }
}
</script>

<style scoped>
h2 {
  color: #2a2a2a;
}
.text-container {
  border: 2px solid #efefef;
  border-radius: 5px;
  padding: 5px;
  height: 250px;
  overflow-y: auto;
}
</style>
